module.exports = __webpack_public_path__ + "static/img/KeeganPalmer.665b160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KeeganPalmer.jpg
// module id = fRMv
// module chunks = 0